<template>
  <div
      class="home page-template-default page page-id-12105 wp-custom-logo header-horizontal site-layout-full elementor-default elementor-kit-12104 elementor-page elementor-page-12105">
    <div class="whole-layout">

      <main-header :tag-index="2"></main-header>

      <div id="mid"
           class="to-move no-top-space no-bottom-space layout-center layout-parted layout-no-edge layout-fixed no-sidebars">
        <article id="content" class="clearfix" itemtype="https://schema.org/CreativeWork" itemscope="">
          <div class="content-limiter" style="width: 100%">
            <div id="col-mask">

              <div id="post-12105" class="content-box post-12105 page type-page status-publish">
                <div class="formatter" style="padding: 0">
                  <div class="real-content" itemprop="text">
                    <div data-elementor-type="wp-post" data-elementor-id="12105"
                         class="elementor elementor-12105" data-elementor-settings="[]">
                      <div class="elementor-section-wrap">
                        <section
                            id="section-2"
                            class="elementor-section elementor-top-section elementor-element elementor-element-c6d7db1 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                            data-id="c6d7db1" data-element_type="section"
                            data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'>
                          <div class="elementor-container elementor-column-gap-no">
                            <div
                                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d91685a"
                                data-id="d91685a" data-element_type="column"
                                data-settings='{"background_background":"classic"}'>
                              <div class="elementor-widget-wrap elementor-element-populated">
                                <section
                                    class="elementor-section elementor-inner-section elementor-element elementor-element-1b4660a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="1b4660a" data-element_type="section">
                                  <div
                                      class="elementor-container elementor-column-gap-no">
                                    <div
                                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f8d6e7c"
                                        data-id="f8d6e7c" data-element_type="column">
                                      <div
                                          class="elementor-widget-wrap elementor-element-populated">
                                        <div
                                            class="elementor-element elementor-element-9a9158c elementor-widget elementor-widget-image"
                                            data-id="9a9158c"
                                            data-element_type="widget"
                                            data-widget_type="image.default">
                                          <div class="elementor-widget-container">
                                            <img
                                                style="width: 350px; margin-right: 80px; margin-top: 240px; margin-bottom: 50px;"
                                                fetchpriority="high"
                                                decoding="async" alt=""
                                                src="@/assets/images/pic-art.png"
                                                class="attachment-full size-full br-lazy"
                                                data-brsrcset="https://www.weeget.cn/wp-content/uploads/2021/11/home-phone-2.png 640w, https://www.weeget.cn/wp-content/uploads/2021/11/home-phone-2-216x300.png 216w"
                                                data-brsizes="(max-width: 640px) 100vw, 640px">
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                        class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-0b91f6d"
                                        data-id="0b91f6d" data-element_type="column">
                                      <div
                                          class="elementor-widget-wrap elementor-element-populated">
                                        <div
                                            class="elementor-element elementor-element-45fbc75 elementor-widget elementor-widget-heading"
                                            data-id="45fbc75"
                                            data-element_type="widget"
                                            data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h3
                                                class="elementor-heading-title elementor-size-default">
                                              配方定制
                                              | <!--span
                                                style="font-weight:300;font-size:1.2em">0</span--> 精准护肤
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                            class="elementor-element elementor-element-bc839c8 elementor-widget elementor-widget-spacer"
                                            data-id="bc839c8"
                                            data-element_type="widget"
                                            data-widget_type="spacer.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-spacer">
                                              <div
                                                  class="elementor-spacer-inner">
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                            class="elementor-element elementor-element-61c9962 elementor-widget elementor-widget-heading"
                                            data-id="61c9962"
                                            data-element_type="widget"
                                            data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h1
                                                class="elementor-heading-title elementor-size-default">
																						<span
                                                style="letter-spacing:22px">给您<span
                                                style="font-weight:600">更多芳香</span></span>
                                            </h1>
                                          </div>
                                        </div>
                                        <div
                                            class="elementor-element elementor-element-65dd0f9 elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                            data-id="65dd0f9"
                                            data-element_type="widget"
                                            data-widget_type="divider.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-divider">
																						<span
                                                class="elementor-divider-separator">
																						</span>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                            class="elementor-element elementor-element-f968b44 elementor-widget elementor-widget-text-editor"
                                            data-id="f968b44"
                                            data-element_type="widget"
                                            data-widget_type="text-editor.default">
                                          <div class="elementor-widget-container">
                                            <p>Aromore品牌融合了“芳香（Aroma）”与“更多（More）”的概念。
                                              <p>寓意着我们的产品成分自然纯净，</p>
                                              <p>同时消费者可以通过我们的产品获得更多的美丽和健康。 </p>
                                              <p>Aromore不仅是功效护肤品品牌，</p>
                                              <p>更是我们对产品质量和效果的坚定承诺。</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="btn-bottom-green" @click="skip('https://www.aromore.com.cn')">
                                    品牌官网
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        </section>
                        <div style="display: flex; align-items: center; justify-content: center">
                          <section
                              style="max-width: 1200px;"
                              id="section-1"
                              class="elementor-section elementor-top-section elementor-element elementor-element-79507e37 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="79507e37" data-element_type="section"
                              data-settings='{"stretch_section":"section-stretched"}'>
                            <div class="elementor-container elementor-column-gap-no">
                              <div
                                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-25c5f6c0"
                                  data-id="25c5f6c0" data-element_type="column">
                                <div class="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      class="elementor-element elementor-element-5800792 elementor-widget elementor-widget-spacer"
                                      data-id="5800792" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-45e9d193 elementor-widget elementor-widget-heading"
                                      data-id="45e9d193" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2
                                          class="elementor-heading-title elementor-size-default">
                                        douhuu</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-46ddab4c elementor-widget elementor-widget-heading"
                                      data-id="46ddab4c" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2
                                          class="elementor-heading-title elementor-size-default">
                                        豆乎</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2a4286dd elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2a4286dd" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-cadad04 elementor-widget elementor-widget-text-editor"
                                      data-id="cadad04" data-element_type="widget"
                                      data-widget_type="text-editor.default">
                                    <div class="elementor-widget-container">
                                      <p>Douhuu品牌专注于青少年护肤领域，致力于为年轻肌肤提供专业护理。</p>
                                      <p>
                                        品牌的核心理念是通过科学配方和温和成分，帮助青少年解决肌肤问题，尤其是痘痘问题。</p>
                                      <p>
                                        通过不断的研究和创新，Douhuu致力于成为青少年护肤领域的领导者，让每一位用户都能享受到安全、有效的护肤产品。</p>
                                      <p>选择豆乎，让青春的您更加靓丽，让美丽成为您青春的永恒印记。 </p>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2f953eb elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2f953eb" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <div class="pic-box">
                            <img class="pic-img" src="@/assets/images/pic-douhu.png" alt>
                          </div>
                        </div>
                        <div class="btn-bottom-deep" @click="skip('https://www.douhuu.com.cn')">
                          品牌官网
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div><!-- #mid -->

      <main-footer></main-footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandView',
  data() {
    return {
      scrolltop: 0,

      // 点击显示弹出框
      isCodePopShow: false,
      // 点击弹出下拉框
      isDropShow: false
    }
  },
  mounted() {
    // 在组件挂载后添加监听器
    window.addEventListener('wheel', this.handleWheel);
  },
  beforeDestroy() {
    // 组件销毁前移除监听器，避免内存泄漏
    window.removeEventListener('wheel', this.handleWheel);
  },
  methods: {
    handleWheel(event) {
      // 阻止默认行为（可选，根据需要）
      // event.preventDefault();
      // 获取滚动到顶部的距离
      this.scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    pathTo(url) {
      this.$router.push({
        path: url
      })
    },
    skip(url) {
      window.open(url);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/style.min.css";
@import "@/assets/static/css/elementor-icons.min.css";
@import "@/assets/static/css/custom-frontend.min.css";
@import "@/assets/static/css/post-12104.css";
@import "@/assets/static/css/global.css";
@import "@/assets/static/css/post-12105.css";
@import "@/assets/static/css/lightgallery.min.css";
@import "@/assets/static/css/font-awesome.min.css";
@import "@/assets/static/css/icomoon.css";
@import "@/assets/static/css/style.css";
@import "@/assets/static/css/user.css";
@import "@/assets/static/css/all.min.css";
@import "@/assets/static/css/v4-shims.min.css";
@import "@/assets/static/css/css-Raleway.css";
@import "@/assets/static/css/post-20.css";
@import "@/assets/static/css/css-SourceSansPro.css";
@import "@/assets/static/css/solid.min.css";
@import "@/assets/static/css/regular.min.css";

a {
  cursor: pointer;
}

.submenu-show {
  display: block;
}

.pic-box {
  width: 200px;

  .pic-img {
    width: 100%;
  }
}

.map-img {

}

.sub-menu-img {
  width: 140px;
}

.btn-bottom-green {
  background: white;
  border-radius: 6px;
  border: 1px solid #035940;
  color: #035940;
  font-size: 18px;
  padding: 10px 30px;
  width: fit-content;
  margin: 0 0 100px;
  cursor: pointer;
  position: relative;
  left: 70%;
}

.btn-bottom-deep {
  background: #035940;
  border-radius: 6px;
  border: 1px solid #035940;
  color: #fff;
  font-size: 18px;
  padding: 10px 30px;
  width: fit-content;
  margin: 0 0 100px;
  cursor: pointer;
  position: relative;
  left: 70%;
}

/*! This file is auto-generated */
.wp-block-button__link {
  color: #fff;
  background-color: #32373c;
  border-radius: 9999px;
  box-shadow: none;
  text-decoration: none;
  padding: calc(.667em + 2px) calc(1.333em + 2px);
  font-size: 1.125em
}

.wp-block-file__button {
  background: #32373c;
  color: #fff;
  text-decoration: none
}

body {
  --wp--preset--color--black: #000000;
  --wp--preset--color--cyan-bluish-gray: #abb8c3;
  --wp--preset--color--white: #ffffff;
  --wp--preset--color--pale-pink: #f78da7;
  --wp--preset--color--vivid-red: #cf2e2e;
  --wp--preset--color--luminous-vivid-orange: #ff6900;
  --wp--preset--color--luminous-vivid-amber: #fcb900;
  --wp--preset--color--light-green-cyan: #7bdcb5;
  --wp--preset--color--vivid-green-cyan: #00d084;
  --wp--preset--color--pale-cyan-blue: #8ed1fc;
  --wp--preset--color--vivid-cyan-blue: #0693e3;
  --wp--preset--color--vivid-purple: #9b51e0;
  --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(135deg, rgba(6, 147, 227, 1) 0%, rgb(155, 81, 224) 100%);
  --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(135deg, rgb(122, 220, 180) 0%, rgb(0, 208, 130) 100%);
  --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(135deg, rgba(252, 185, 0, 1) 0%, rgba(255, 105, 0, 1) 100%);
  --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(135deg, rgba(255, 105, 0, 1) 0%, rgb(207, 46, 46) 100%);
  --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(135deg, rgb(238, 238, 238) 0%, rgb(169, 184, 195) 100%);
  --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(135deg, rgb(74, 234, 220) 0%, rgb(151, 120, 209) 20%, rgb(207, 42, 186) 40%, rgb(238, 44, 130) 60%, rgb(251, 105, 98) 80%, rgb(254, 248, 76) 100%);
  --wp--preset--gradient--blush-light-purple: linear-gradient(135deg, rgb(255, 206, 236) 0%, rgb(152, 150, 240) 100%);
  --wp--preset--gradient--blush-bordeaux: linear-gradient(135deg, rgb(254, 205, 165) 0%, rgb(254, 45, 45) 50%, rgb(107, 0, 62) 100%);
  --wp--preset--gradient--luminous-dusk: linear-gradient(135deg, rgb(255, 203, 112) 0%, rgb(199, 81, 192) 50%, rgb(65, 88, 208) 100%);
  --wp--preset--gradient--pale-ocean: linear-gradient(135deg, rgb(255, 245, 203) 0%, rgb(182, 227, 212) 50%, rgb(51, 167, 181) 100%);
  --wp--preset--gradient--electric-grass: linear-gradient(135deg, rgb(202, 248, 128) 0%, rgb(113, 206, 126) 100%);
  --wp--preset--gradient--midnight: linear-gradient(135deg, rgb(2, 3, 129) 0%, rgb(40, 116, 252) 100%);
  --wp--preset--font-size--small: 13px;
  --wp--preset--font-size--medium: 20px;
  --wp--preset--font-size--large: 36px;
  --wp--preset--font-size--x-large: 42px;
  --wp--preset--spacing--20: 0.44rem;
  --wp--preset--spacing--30: 0.67rem;
  --wp--preset--spacing--40: 1rem;
  --wp--preset--spacing--50: 1.5rem;
  --wp--preset--spacing--60: 2.25rem;
  --wp--preset--spacing--70: 3.38rem;
  --wp--preset--spacing--80: 5.06rem;
  --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
  --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1), 6px 6px rgba(0, 0, 0, 1);
  --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
}

:where(.is-layout-flex) {
  gap: 0.5em;
}

:where(.is-layout-grid) {
  gap: 0.5em;
}

body .is-layout-flex {
  display: flex;
}

body .is-layout-flex {
  flex-wrap: wrap;
  align-items: center;
}

body .is-layout-flex > * {
  margin: 0;
}

body .is-layout-grid {
  display: grid;
}

body .is-layout-grid > * {
  margin: 0;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

.has-black-color {
  color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-color {
  color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-color {
  color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-color {
  color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-color {
  color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-color {
  color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-color {
  color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-color {
  color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-color {
  color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-color {
  color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-color {
  color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-color {
  color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-background-color {
  background-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-background-color {
  background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-background-color {
  background-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-background-color {
  background-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-background-color {
  background-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-background-color {
  background-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-background-color {
  background-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-background-color {
  background-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-background-color {
  background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-background-color {
  background-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-border-color {
  border-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-border-color {
  border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-border-color {
  border-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-border-color {
  border-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-border-color {
  border-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-border-color {
  border-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-border-color {
  border-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-border-color {
  border-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-border-color {
  border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-border-color {
  border-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-vivid-cyan-blue-to-vivid-purple-gradient-background {
  background: var(--wp--preset--gradient--vivid-cyan-blue-to-vivid-purple) !important;
}

.has-light-green-cyan-to-vivid-green-cyan-gradient-background {
  background: var(--wp--preset--gradient--light-green-cyan-to-vivid-green-cyan) !important;
}

.has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange) !important;
}

.has-luminous-vivid-orange-to-vivid-red-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-orange-to-vivid-red) !important;
}

.has-very-light-gray-to-cyan-bluish-gray-gradient-background {
  background: var(--wp--preset--gradient--very-light-gray-to-cyan-bluish-gray) !important;
}

.has-cool-to-warm-spectrum-gradient-background {
  background: var(--wp--preset--gradient--cool-to-warm-spectrum) !important;
}

.has-blush-light-purple-gradient-background {
  background: var(--wp--preset--gradient--blush-light-purple) !important;
}

.has-blush-bordeaux-gradient-background {
  background: var(--wp--preset--gradient--blush-bordeaux) !important;
}

.has-luminous-dusk-gradient-background {
  background: var(--wp--preset--gradient--luminous-dusk) !important;
}

.has-pale-ocean-gradient-background {
  background: var(--wp--preset--gradient--pale-ocean) !important;
}

.has-electric-grass-gradient-background {
  background: var(--wp--preset--gradient--electric-grass) !important;
}

.has-midnight-gradient-background {
  background: var(--wp--preset--gradient--midnight) !important;
}

.has-small-font-size {
  font-size: var(--wp--preset--font-size--small) !important;
}

.has-medium-font-size {
  font-size: var(--wp--preset--font-size--medium) !important;
}

.has-large-font-size {
  font-size: var(--wp--preset--font-size--large) !important;
}

.has-x-large-font-size {
  font-size: var(--wp--preset--font-size--x-large) !important;
}

.wp-block-navigation a:where(:not(.wp-element-button)) {
  color: inherit;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

.wp-block-pullquote {
  font-size: 1.5em;
  line-height: 1.6;
}

/*脚部调整*/
#footer.centered {
  text-align: left;
}

#footer.centered, #footer.centered .widget h3.title, #footer.centered .widget .socials {
  text-align: left;
}

.foot-items, #footer .foot-widgets {
  padding-left: 200px;
}

@media screen and (max-width: 480px) {
  .widget {
    text-align: left;
  }
  .foot-items, #footer .foot-widgets {
    padding-left: 20px;
  }
}

.foot-img {
  display: flex;
  justify-content: center;
}

#footer .widget {
  font-size: 15px;
}

/*横杠*/
.elementor-divider-separator {
  border-radius: 8px;
}

/*分类归档名称调整*/
.posts-list .title-bar.outside .page-title {
  font-size: 0;
  padding-top: 30px;
}

.posts-list .title-bar.outside .page-title span {
  font-size: 48px;
}

/*菜单间距*/
.header-horizontal .top-menu > li > a {
  padding: 0 16px;
}

/*新闻动态*/
h2.post-title {
  font-size: 1em;
  line-height: 1.4em;
}

.item-image a::before {
  background-color: #0000008c;
}

.item-image a::after {
  font-size: 0;
}

@media only screen and (max-width: 768px) {
  .bricks-frame .formatter {
    padding-left: 0;
  }
}

.bricks-frame .formatter, .post_theme_options .formatter {
  padding-top: 20px;
}

/*规则菜单*/
.widget_nav_menu ul ul {
  margin: 0 0 0 16px;
}

</style>
